import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import {
  gloves,
  handtools,
  pumps,
  services16,
  services2,
  services3Other,
  services4,
  services5,
  services6,
  services7,
  services8,
  services9,
  servicesRightHover,
} from "../../../assets/images";

const Supply = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const newsItems = [
    {
      id: 1,
      imgSrc: services8,
      title: "Drill bits",
      path: "supply/drillbits",
    },
    {
      id: 2,
      imgSrc: services16,
      title: "Directional drilling (Downhole Motors)",
      path: "supply/directional",
    },
    {
      id: 3,
      imgSrc: services9,
      title: "Fiber glass tubes for cementing and coring job",
      path: "supply/fiber",
    },
    {
      id: 4,
      imgSrc: services2,
      title: "Liner hangers",
      path: "supply/liner",
    },
    {
      id: 5,
      imgSrc: services6,
      title: "Whipstocks",
      path: "supply/whipstock",
    },
    {
      id: 6,
      imgSrc: services3Other,
      title: "Core bit",
      path: "supply/corebit",
    },
    {
      id: 7,
      imgSrc: services4,
      title: "Pressure testing: Hydrostatic pressure testing",
      path: "supply/hydro",
    },
    {
      id: 8,
      imgSrc: services5,
      title: "Pressure testing: Gas pressure testing",
      path: "supply/gas",
    },
    {
      id: 9,
      imgSrc: services7,
      title: "Pressure testing: Pressure test bays",
      path: "supply/pressure",
    },
    {
      id: 10,
      imgSrc: pumps,
      title: "Pumps, compressors",
      path: "industrial/supply/pumps-compressor",
    },
    {
      id: 11,
      imgSrc: gloves,
      title: "PPE Equipment",
      path: "industrial/supply/gloves",
    },
    {
      id: 12,
      imgSrc: handtools,
      title: "Hand tools, measuring instruments",
      path: "industrial/supply/hand-tools",
    },
  ];

  return (
    <div className="bg-[#EDEDED] pt-10 md:pt-20">
      <div className="max-w-containerSm md:max-w-container mx-auto">
        <div className="text-center">
          <p className="text-[#B31F11] text-[14px] font-medium">SUPPLY</p>
          <p className="text-[#141615] font-firstFont text-[28px] md:text-[44px] font-bold">
            Reliable Supply
          </p>
        </div>
        <div className="mt-6 md:mt-10">
          <Swiper
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".swiper-button-next-custom2",
              prevEl: ".swiper-button-prev-custom2",
            }}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Navigation, Autoplay]}
            breakpoints={{
              480: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 3 },
            }}
          >
            {newsItems.map((item) => (
              <SwiperSlide key={item.id}>
                <a
                  key={item.id}
                  href={`/${currentLanguage}/supply/${item.path}`}
                >
                  <div className="relative md:w-[370px] h-[372px] md:h-[440px] group overflow-hidden rounded-lg">
                    {/* Image */}
                    <img
                      src={item.imgSrc}
                      className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                      alt=""
                    />

                    {/* Title overlay with blur background */}
                    <div className="absolute bottom-0 w-full flex items-center justify-between h-[72px] md:h-[84px] py-3 px-9 bg-black/50 backdrop-blur-md text-white text-[18px] md:text-[20px] font-medium">
                      <p>{t(item.title)}</p>
                      <img
                        alt="Right arrow"
                        className="w-6 h-6"
                        src={servicesRightHover}
                      ></img>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex justify-center mt-6 md:mt-10">
          <a className="w-full md:w-auto" href={`/${currentLanguage}/`}>
            <button className="bg-[#B31F11] text-white md:w-[136px] w-full h-[44px] rounded">
              More Info
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Supply;
